import React from 'react';
import translate from '../../../../utils/translate';

export default class HeaderMyAccountSection extends React.Component {
  static propTypes = {
    myAccount: React.PropTypes.object,
    type:      React.PropTypes.string
  };

  render () {
    const section = this.props.myAccount[this.props.type];
    if (!section || !section.url) {
      return false;
    }

    const tuName = this.getSectionTUName(this.props.type);

    return (
      <a
        className="header__panel__item"
        href={section.url}
        data-component="myaccount-header-link">
        <h4 className="header__panel__item__heading">
          {translate('myAccountModule', tuName)}
        </h4>
        <p className="header__panel__item__description">
          {translate('myAccountModule', tuName + '_DESC')}
        </p>
      </a>
    );
  }

  getSectionTUName = (section) => {
    if (section === 'profile') {
      return 'EDIT_PROFILE';
    }
    else if (section === 'upcomingEvents') {
      return 'MY_TICKETS';
    }
    else if (section === 'pastEvents') {
      return 'PAST_EVENTS';
    }
    else if (section === 'address') {
      return 'EDIT_ADDRESS';
    }
    else if (section === 'newsletter') {
      return 'NEWSLETTER';
    }
  };
}



// WEBPACK FOOTER //
// ./frontend/react/components/header/account/myaccountsection/index.js